<div class="c1">

    <div class="c">
        <!-- <div class="row">
    <div class="line"></div> -->
        <!-- <mat-card class="item" *ngFor="let number of array">
   
    <div class="line"></div>
    <div class="row1">
    <div class="wastename">
    <p style="padding-top: 10px;">{{number}}</p>
</div>
    
    <div class="counter">
    <button mat-mini-fab color="white" style="color:white" aria-label="profile icon" (click)="increase()" class="btn" >
        <mat-icon class="btnicon">add</mat-icon>
    </button>
    <p style="margin-right: 7px;padding-left: 7px;padding-top: 7px;" class="counternum">{{counter}}</p>
    <button mat-mini-fab color="white" style="color:white" aria-label="profile icon" (click)="decrease()" class="btn">
        <mat-icon class="btnicon">remove</mat-icon>
    </button>
</div>
</div>

<div class="row2">
    <div class="perkiloprice">
        <p>{{publicservice.Texts.Texts["selected-items2"]}}</p>
        <p style="padding-right: 5px;">2000</p>
    </div>
<div class="maxprice">
    <p>{{publicservice.Texts.Texts["selected-items1"]}}</p>
    <p style="padding-right: 5px;">2000</p>
</div>

</div>
</mat-card> -->
<div [class]="displayPet">
        <div [class]="petStatus">
            <mat-card id="item">

                <div class="line"></div>
                <div style="width: 100%;text-align: right;padding-right: 10px;cursor: pointer;">
                    <mat-icon style="color: #67b758;" (click)="cancelPet()">close</mat-icon>
                </div>
                <div class="row1">
                    <div class="wastename">
                        <p style="padding-top: 10px;">{{publicservice.Texts.Texts['waste-list14']}}</p>
                    </div>

                    <div class="counter">
                        <button mat-mini-fab color="white" style="color:white" aria-label="profile icon"
                            (click)="petIncrease()" class="btn">
                            <mat-icon class="btnicon">add</mat-icon>
                        </button>
                        <p style="margin-right: 7px;padding-left: 7px;padding-top: 7px;" class="counternum">
                            {{petCounter}}
                        </p>
                        <button mat-mini-fab color="white" style="color:white" aria-label="profile icon"
                            (click)="petDecrease()" class="btn">
                            <mat-icon class="btnicon">remove</mat-icon>
                        </button>
                    </div>
                </div>

                <div class="row2">
                    <div class="perkiloprice">
                        <p>{{publicservice.Texts.Texts["selected-items2"]}}</p>
                        <p style="padding-right: 5px;">{{petPerKilo}}</p>
                    </div>
                    <div class="maxprice">
                        <p>{{publicservice.Texts.Texts["selected-items1"]}}</p>
                        <p style="padding-right: 5px;">{{petMaxPrice}}</p>
                    </div>

                </div>
            </mat-card>
        </div>
        </div>

        <div [class]="displayAlSabok">
        <div [class]="alSabokStatus">
            <mat-card id="item">

                <div class="line"></div>
                <div style="width: 100%;text-align: right;padding-right: 10px;cursor: pointer;">
                    <mat-icon style="color: #67b758;" (click)="cancelAlSabok()">close</mat-icon>
                </div>
                <div class="row1">
                    <div class="wastename">
                        <p style="padding-top: 10px;">{{publicservice.Texts.Texts['waste-list17']}}</p>
                    </div>

                    <div class="counter">
                        <button mat-mini-fab color="white" style="color:white" aria-label="profile icon"
                            (click)="alSabokIncrease()" class="btn">
                            <mat-icon class="btnicon">add</mat-icon>
                        </button>
                        <p style="margin-right: 7px;padding-left: 7px;padding-top: 7px;" class="counternum">
                            {{alSabokCounter}}
                        </p>
                        <button mat-mini-fab color="white" style="color:white" aria-label="profile icon"
                            (click)="alSabokDecrease()" class="btn">
                            <mat-icon class="btnicon">remove</mat-icon>
                        </button>
                    </div>
                </div>

                <div class="row2">
                    <div class="perkiloprice">
                        <p>{{publicservice.Texts.Texts["selected-items2"]}}</p>
                        <p style="padding-right: 5px;">{{alSabokPerKilo}}</p>
                    </div>
                    <div class="maxprice">
                        <p>{{publicservice.Texts.Texts["selected-items1"]}}</p>
                        <p style="padding-right: 5px;">{{alSabokMaxPrice}}</p>
                    </div>

                </div>
            </mat-card>
        </div>
        </div>

        <div [class]="displayAlSangin">
        <div [class]="alSanginStatus">
            <mat-card id="item">

                <div class="line"></div>
                <div style="width: 100%;text-align: right;padding-right: 10px;cursor: pointer;">
                    <mat-icon style="color: #67b758;" (click)="cancelAlSangin()">close</mat-icon>
                </div>
                <div class="row1">
                    <div class="wastename">
                        <p style="padding-top: 10px;">{{publicservice.Texts.Texts['waste-list18']}}</p>
                    </div>

                    <div class="counter">
                        <button mat-mini-fab color="white" style="color:white" aria-label="profile icon"
                            (click)="alSanginIncrease()" class="btn">
                            <mat-icon class="btnicon">add</mat-icon>
                        </button>
                        <p style="margin-right: 7px;padding-left: 7px;padding-top: 7px;" class="counternum">
                            {{alSanginCounter}}
                        </p>
                        <button mat-mini-fab color="white" style="color:white" aria-label="profile icon"
                            (click)="alSanginDecrease()" class="btn">
                            <mat-icon class="btnicon">remove</mat-icon>
                        </button>
                    </div>
                </div>

                <div class="row2">
                    <div class="perkiloprice">
                        <p>{{publicservice.Texts.Texts["selected-items2"]}}</p>
                        <p style="padding-right: 5px;">{{alSanginPerKilo}}</p>
                    </div>
                    <div class="maxprice">
                        <p>{{publicservice.Texts.Texts["selected-items1"]}}</p>
                        <p style="padding-right: 5px;">{{alSanginMaxPrice}}</p>
                    </div>

                </div>
            </mat-card>
        </div>
    </div>


        <div [class]="displayIron">
        <div [class]="ironStatus">
            <mat-card id="item">

                <div class="line"></div>
                <div style="width: 100%;text-align: right;padding-right: 10px;cursor: pointer;">
                    <mat-icon style="color: #67b758;" (click)="cancelIron()">close</mat-icon>
                </div>
                <div class="row1">
                    <div class="wastename">
                        <p style="padding-top: 10px;">{{publicservice.Texts.Texts['waste-list11']}}</p>
                    </div>

                    <div class="counter">
                        <button mat-mini-fab color="white" style="color:white" aria-label="profile icon"
                            (click)="ironIncrease()" class="btn">
                            <mat-icon class="btnicon">add</mat-icon>
                        </button>
                        <p style="margin-right: 7px;padding-left: 7px;padding-top: 7px;" class="counternum">
                            {{ironCounter}}
                        </p>
                        <button mat-mini-fab color="white" style="color:white" aria-label="profile icon"
                            (click)="ironDecrease()" class="btn">
                            <mat-icon class="btnicon">remove</mat-icon>
                        </button>
                    </div>
                </div>

                <div class="row2">
                    <div class="perkiloprice">
                        <p>{{publicservice.Texts.Texts["selected-items2"]}}</p>
                        <p style="padding-right: 5px;">{{ironPerKilo}}</p>
                    </div>
                    <div class="maxprice">
                        <p>{{publicservice.Texts.Texts["selected-items1"]}}</p>
                        <p style="padding-right: 5px;">{{ironMaxPrice}}</p>
                    </div>

                </div>
            </mat-card>
        </div>
        </div>

        <div [class]="displayCpu">
        <div [class]="cpuStatus">
            <mat-card id="item">

                <div class="line"></div>
                <div style="width: 100%;text-align: right;padding-right: 10px;cursor: pointer;">
                    <mat-icon style="color: #67b758;" (click)="cancelCpu()">close</mat-icon>
                </div>
                <div class="row1">
                    <div class="wastename">
                        <p style="padding-top: 10px;">{{publicservice.Texts.Texts['waste-list10']}}</p>
                    </div>

                    <div class="counter">
                        <button mat-mini-fab color="white" style="color:white" aria-label="profile icon"
                            (click)="cpuIncrease()" class="btn">
                            <mat-icon class="btnicon">add</mat-icon>
                        </button>
                        <p style="margin-right: 7px;padding-left: 7px;padding-top: 7px;" class="counternum">
                            {{cpuCounter}}
                        </p>
                        <button mat-mini-fab color="white" style="color:white" aria-label="profile icon"
                            (click)="cpuDecrease()" class="btn">
                            <mat-icon class="btnicon">remove</mat-icon>
                        </button>
                    </div>
                </div>

                <div class="row2">
                    <div class="perkiloprice">
                        <p>{{publicservice.Texts.Texts["selected-items2"]}}</p>
                        <p style="padding-right: 5px;">{{cpuPerKilo}}</p>
                    </div>
                    <div class="maxprice">
                        <p>{{publicservice.Texts.Texts["selected-items1"]}}</p>
                        <p style="padding-right: 5px;">{{cpuMaxPrice}}</p>
                    </div>

                </div>
            </mat-card>
        </div>
        </div>

        <div [class]="displayRice">
        <div [class]="riceStatus">
            <mat-card id="item">

                <div class="line"></div>
                <div style="width: 100%;text-align: right;padding-right: 10px;cursor: pointer;">
                    <mat-icon style="color: #67b758;" (click)="cancelRice()">close</mat-icon>
                </div>
                <div class="row1">
                    <div class="wastename">
                        <p style="padding-top: 10px;">{{publicservice.Texts.Texts['waste-list9']}}</p>
                    </div>

                    <div class="counter">
                        <button mat-mini-fab color="white" style="color:white" aria-label="profile icon"
                            (click)="riceIncrease()" class="btn">
                            <mat-icon class="btnicon">add</mat-icon>
                        </button>
                        <p style="margin-right: 7px;padding-left: 7px;padding-top: 7px;" class="counternum">
                            {{riceCounter}}
                        </p>
                        <button mat-mini-fab color="white" style="color:white" aria-label="profile icon"
                            (click)="riceDecrease()" class="btn">
                            <mat-icon class="btnicon">remove</mat-icon>
                        </button>
                    </div>
                </div>

                <div class="row2">
                    <div class="perkiloprice">
                        <p>{{publicservice.Texts.Texts["selected-items2"]}}</p>
                        <p style="padding-right: 5px;">{{ricePerKilo}}</p>
                    </div>
                    <div class="maxprice">
                        <p>{{publicservice.Texts.Texts["selected-items1"]}}</p>
                        <p style="padding-right: 5px;">{{riceMaxPrice}}</p>
                    </div>

                </div>
            </mat-card>
        </div>
        </div>


        <div [class]="displayPlastic">
        <div [class]="plasticStatus">
            <mat-card id="item">

                <div class="line"></div>
                <div style="width: 100%;text-align: right;padding-right: 10px;cursor: pointer;">
                    <mat-icon style="color: #67b758;" (click)="cancelPlastic()">close</mat-icon>
                </div>
                <div class="row1">
                    <div class="wastename">
                        <p style="padding-top: 10px;">{{publicservice.Texts.Texts['waste-list5']}}</p>
                    </div>

                    <div class="counter">
                        <button mat-mini-fab color="white" style="color:white" aria-label="profile icon"
                            (click)="plasticIncrease()" class="btn">
                            <mat-icon class="btnicon">add</mat-icon>
                        </button>
                        <p style="margin-right: 7px;padding-left: 7px;padding-top: 7px;" class="counternum">
                            {{plasticCounter}}
                        </p>
                        <button mat-mini-fab color="white" style="color:white" aria-label="profile icon"
                            (click)="plasticDecrease()" class="btn">
                            <mat-icon class="btnicon">remove</mat-icon>
                        </button>
                    </div>
                </div>

                <div class="row2">
                    <div class="perkiloprice">
                        <p>{{publicservice.Texts.Texts["selected-items2"]}}</p>
                        <p style="padding-right: 5px;">{{plasticPerKilo}}</p>
                    </div>
                    <div class="maxprice">
                        <p>{{publicservice.Texts.Texts["selected-items1"]}}</p>
                        <p style="padding-right: 5px;">{{plasticMaxPrice}}</p>
                    </div>

                </div>
            </mat-card>
        </div>
        </div>

        <div [class]="displayChodan">
        <div [class]="chodanStatus">
            <mat-card id="item">

                <div class="line"></div>
                <div style="width: 100%;text-align: right;padding-right: 10px;cursor: pointer;">
                    <mat-icon style="color: #67b758;" (click)="cancelChodan()">close</mat-icon>
                </div>
                <div class="row1">
                    <div class="wastename">
                        <p style="padding-top: 10px;">{{publicservice.Texts.Texts['waste-list13']}}</p>
                    </div>

                    <div class="counter">
                        <button mat-mini-fab color="white" style="color:white" aria-label="profile icon"
                            (click)="chodanIncrease()" class="btn">
                            <mat-icon class="btnicon">add</mat-icon>
                        </button>
                        <p style="margin-right: 7px;padding-left: 7px;padding-top: 7px;" class="counternum">
                            {{chodanCounter}}
                        </p>
                        <button mat-mini-fab color="white" style="color:white" aria-label="profile icon"
                            (click)="chodanDecrease()" class="btn">
                            <mat-icon class="btnicon">remove</mat-icon>
                        </button>
                    </div>
                </div>

                <div class="row2">
                    <div class="perkiloprice">
                        <p>{{publicservice.Texts.Texts["selected-items2"]}}</p>
                        <p style="padding-right: 5px;">{{chodanPerKilo}}</p>
                    </div>
                    <div class="maxprice">
                        <p>{{publicservice.Texts.Texts["selected-items1"]}}</p>
                        <p style="padding-right: 5px;">{{chodanMaxPrice}}</p>
                    </div>

                </div>
            </mat-card>
        </div>
    </div>


        <div [class]="displayCan">
        <div [class]="canStatus">
            <mat-card id="item">

                <div class="line"></div>
                <div style="width: 100%;text-align: right;padding-right: 10px;cursor: pointer;">
                    <mat-icon style="color: #67b758;" (click)="cancelCan()">close</mat-icon>
                </div>
                <div class="row1">
                    <div class="wastename">
                        <p style="padding-top: 10px;">{{publicservice.Texts.Texts['waste-list6']}}</p>
                    </div>

                    <div class="counter">
                        <button mat-mini-fab color="white" style="color:white" aria-label="profile icon"
                            (click)="canIncrease()" class="btn">
                            <mat-icon class="btnicon">add</mat-icon>
                        </button>
                        <p style="margin-right: 7px;padding-left: 7px;padding-top: 7px;" class="counternum">
                            {{canCounter}}
                        </p>
                        <button mat-mini-fab color="white" style="color:white" aria-label="profile icon"
                            (click)="canDecrease()" class="btn">
                            <mat-icon class="btnicon">remove</mat-icon>
                        </button>
                    </div>
                </div>

                <div class="row2">
                    <div class="perkiloprice">
                        <p>{{publicservice.Texts.Texts["selected-items2"]}}</p>
                        <p style="padding-right: 5px;">{{canPerKilo}}</p>
                    </div>
                    <div class="maxprice">
                        <p>{{publicservice.Texts.Texts["selected-items1"]}}</p>
                        <p style="padding-right: 5px;">{{canMaxPrice}}</p>
                    </div>

                </div>
            </mat-card>
        </div>
        </div>

        <div [class]="displayBasket">
        <div [class]="basketStatus">
            <mat-card id="item">

                <div class="line"></div>
                <div style="width: 100%;text-align: right;padding-right: 10px;cursor: pointer;">
                    <mat-icon style="color: #67b758;" (click)="cancelBasket()">close</mat-icon>
                </div>
                <div class="row1">
                    <div class="wastename">
                        <p style="padding-top: 10px;">{{publicservice.Texts.Texts['waste-list15']}}</p>
                    </div>

                    <div class="counter">
                        <button mat-mini-fab color="white" style="color:white" aria-label="profile icon"
                            (click)="basketIncrease()" class="btn">
                            <mat-icon class="btnicon">add</mat-icon>
                        </button>
                        <p style="margin-right: 7px;padding-left: 7px;padding-top: 7px;" class="counternum">
                            {{basketCounter}}
                        </p>
                        <button mat-mini-fab color="white" style="color:white" aria-label="profile icon"
                            (click)="basketDecrease()" class="btn">
                            <mat-icon class="btnicon">remove</mat-icon>
                        </button>
                    </div>
                </div>

                <div class="row2">
                    <div class="perkiloprice">
                        <p>{{publicservice.Texts.Texts["selected-items2"]}}</p>
                        <p style="padding-right: 5px;">{{basketPerKilo}}</p>
                    </div>
                    <div class="maxprice">
                        <p>{{publicservice.Texts.Texts["selected-items1"]}}</p>
                        <p style="padding-right: 5px;">{{basketMaxPrice}}</p>
                    </div>

                </div>
            </mat-card>
        </div>
    </div>

        <div [class]="displayBottle">
        <div [class]="bottleStatus">
            <mat-card id="item">

                <div class="line"></div>
                <div style="width: 100%;text-align: right;padding-right: 10px;cursor: pointer;">
                    <mat-icon style="color: #67b758;" (click)="cancelBottle()">close</mat-icon>
                </div>
                <div class="row1">
                    <div class="wastename">
                        <p style="padding-top: 10px;">{{publicservice.Texts.Texts['waste-list3']}}</p>
                    </div>

                    <div class="counter">
                        <button mat-mini-fab color="white" style="color:white" aria-label="profile icon"
                            (click)="bottleIncrease()" class="btn">
                            <mat-icon class="btnicon">add</mat-icon>
                        </button>
                        <p style="margin-right: 7px;padding-left: 7px;padding-top: 7px;" class="counternum">
                            {{bottleCounter}}
                        </p>
                        <button mat-mini-fab color="white" style="color:white" aria-label="profile icon"
                            (click)="bottleDecrease()" class="btn">
                            <mat-icon class="btnicon">remove</mat-icon>
                        </button>
                    </div>
                </div>

                <div class="row2">
                    <div class="perkiloprice">
                        <p>{{publicservice.Texts.Texts["selected-items2"]}}</p>
                        <p style="padding-right: 5px;">{{bottlePerKilo}}</p>
                    </div>
                    <div class="maxprice">
                        <p>{{publicservice.Texts.Texts["selected-items1"]}}</p>
                        <p style="padding-right: 5px;">{{bottleMaxPrice}}</p>
                    </div>

                </div>
            </mat-card>
        </div>
        </div>

        <div [class]="displayShoes">
            <div [class]="shoesStatus">
                <mat-card id="item">

                    <div class="line"></div>
                    <div style="width: 100%;text-align: right;padding-right: 10px;cursor: pointer;">
                        <mat-icon style="color: #67b758;" (click)="cancelShoes()">close</mat-icon>
                    </div>
                    <div class="row1">
                        <div class="wastename">
                            <p style="padding-top: 10px;">{{publicservice.Texts.Texts['waste-list4']}}</p>
                        </div>

                        <div class="counter">
                            <button mat-mini-fab color="white" style="color:white" aria-label="profile icon"
                                (click)="shoesIncrease()" class="btn">
                                <mat-icon class="btnicon">add</mat-icon>
                            </button>
                            <p style="margin-right: 7px;padding-left: 7px;padding-top: 7px;" class="counternum">
                                {{shoesCounter}}
                            </p>
                            <button mat-mini-fab color="white" style="color:white" aria-label="profile icon"
                                (click)="shoesDecrease()" class="btn">
                                <mat-icon class="btnicon">remove</mat-icon>
                            </button>
                        </div>
                    </div>

                    <div class="row2">
                        <div class="perkiloprice">
                            <p>{{publicservice.Texts.Texts["selected-items2"]}}</p>
                            <p style="padding-right: 5px;">{{shoesPerKilo}}</p>
                        </div>
                        <div class="maxprice">
                            <p>{{publicservice.Texts.Texts["selected-items1"]}}</p>
                            <p style="padding-right: 5px;">{{shoesMaxPrice}}</p>
                        </div>

                    </div>
                </mat-card>
            </div>
        </div>

        <div [class]="displayPaper">
            <div [class]="paperStatus">
                <mat-card id="item">

                    <div class="line"></div>
                    <div style="width: 100%;text-align: right;padding-right: 10px;cursor: pointer;">
                        <mat-icon style="color: #67b758;" (click)="cancelPaper()">close</mat-icon>
                    </div>
                    <div class="row1">
                        <div class="wastename">
                            <p style="padding-top: 10px;">{{publicservice.Texts.Texts['waste-list2']}}</p>
                        </div>

                        <div class="counter">
                            <button mat-mini-fab color="white" style="color:white" aria-label="profile icon"
                                (click)="paperIncrease()" class="btn">
                                <mat-icon class="btnicon">add</mat-icon>
                            </button>
                            <p style="margin-right: 7px;padding-left: 7px;padding-top: 7px;" class="counternum">
                                {{paperCounter}}
                            </p>
                            <button mat-mini-fab color="white" style="color:white" aria-label="profile icon"
                                (click)="paperDecrease()" class="btn">
                                <mat-icon class="btnicon">remove</mat-icon>
                            </button>
                        </div>
                    </div>

                    <div class="row2">
                        <div class="perkiloprice">
                            <p>{{publicservice.Texts.Texts["selected-items2"]}}</p>
                            <p style="padding-right: 5px;">{{paperPerKilo}}</p>
                        </div>
                        <div class="maxprice">
                            <p>{{publicservice.Texts.Texts["selected-items1"]}}</p>
                            <p style="padding-right: 5px;">{{paperMaxPrice}}</p>
                        </div>

                    </div>
                </mat-card>
            </div>
        </div>


        <div [class]="displayLak">
        <div [class]="lakStatus">
            <mat-card id="item">

                <div class="line"></div>
                <div style="width: 100%;text-align: right;padding-right: 10px;cursor: pointer;">
                    <mat-icon style="color: #67b758;" (click)="cancelLak()">close</mat-icon>
                </div>
                <div class="row1">
                    <div class="wastename">
                        <p style="padding-top: 10px;">{{publicservice.Texts.Texts['waste-list16']}}</p>
                    </div>

                    <div class="counter">
                        <button mat-mini-fab color="white" style="color:white" aria-label="profile icon"
                            (click)="lakIncrease()" class="btn">
                            <mat-icon class="btnicon">add</mat-icon>
                        </button>
                        <p style="margin-right: 7px;padding-left: 7px;padding-top: 7px;" class="counternum">
                            {{lakCounter}}
                        </p>
                        <button mat-mini-fab color="white" style="color:white" aria-label="profile icon"
                            (click)="lakDecrease()" class="btn">
                            <mat-icon class="btnicon">remove</mat-icon>
                        </button>
                    </div>
                </div>

                <div class="row2">
                    <div class="perkiloprice">
                        <p>{{publicservice.Texts.Texts["selected-items2"]}}</p>
                        <p style="padding-right: 5px;">{{lakPerKilo}}</p>
                    </div>
                    <div class="maxprice">
                        <p>{{publicservice.Texts.Texts["selected-items1"]}}</p>
                        <p style="padding-right: 5px;">{{lakMaxPrice}}</p>
                    </div>

                </div>
            </mat-card>
        </div>
    </div>


    <div [class]="displayDry">
        <div [class]="dryStatus">
            <mat-card id="item">

                <div class="line"></div>
                <div style="width: 100%;text-align: right;padding-right: 10px;cursor: pointer;">
                    <mat-icon style="color: #67b758;" (click)="cancelDry()">close</mat-icon>
                </div>
                <div class="row1">
                    <div class="wastename">
                        <p style="padding-top: 10px;">{{publicservice.Texts.Texts['waste-list1']}}</p>
                    </div>

                    <div class="counter">
                        <button mat-mini-fab color="white" style="color:white" aria-label="profile icon"
                            (click)="dryIncrease()" class="btn">
                            <mat-icon class="btnicon">add</mat-icon>
                        </button>
                        <p style="margin-right: 7px;padding-left: 7px;padding-top: 7px;" class="counternum">
                            {{dryCounter}}
                        </p>
                        <button mat-mini-fab color="white" style="color:white" aria-label="profile icon"
                            (click)="dryDecrease()" class="btn">
                            <mat-icon class="btnicon">remove</mat-icon>
                        </button>
                    </div>
                </div>

                <div class="row2">
                    <div class="perkiloprice">
                        <p>{{publicservice.Texts.Texts["selected-items2"]}}</p>
                        <p style="padding-right: 5px;">{{dryPerKilo}}</p>
                    </div>
                    <div class="maxprice">
                        <p>{{publicservice.Texts.Texts["selected-items1"]}}</p>
                        <p style="padding-right: 5px;">{{dryMaxPrice}}</p>
                    </div>

                </div>
            </mat-card>
        </div>
        </div>

        <div [class]="displayMes">
        <div [class]="mesStatus">
            <mat-card id="item">

                <div class="line"></div>
                <div style="width: 100%;text-align: right;padding-right: 10px;cursor: pointer;">
                    <mat-icon style="color: #67b758;" (click)="cancelMes()">close</mat-icon>
                </div>
                <div class="row1">
                    <div class="wastename">
                        <p style="padding-top: 10px;">{{publicservice.Texts.Texts['waste-list12']}}</p>
                    </div>

                    <div class="counter">
                        <button mat-mini-fab color="white" style="color:white" aria-label="profile icon"
                            (click)="mesIncrease()" class="btn">
                            <mat-icon class="btnicon">add</mat-icon>
                        </button>
                        <p style="margin-right: 7px;padding-left: 7px;padding-top: 7px;" class="counternum">
                            {{mesCounter}}
                        </p>
                        <button mat-mini-fab color="white" style="color:white" aria-label="profile icon"
                            (click)="mesDecrease()" class="btn">
                            <mat-icon class="btnicon">remove</mat-icon>
                        </button>
                    </div>
                </div>

                <div class="row2">
                    <div class="perkiloprice">
                        <p>{{publicservice.Texts.Texts["selected-items2"]}}</p>
                        <p style="padding-right: 5px;">{{mesPerKilo}}</p>
                    </div>
                    <div class="maxprice">
                        <p>{{publicservice.Texts.Texts["selected-items1"]}}</p>
                        <p style="padding-right: 5px;">{{mesMaxPrice}}</p>
                    </div>

                </div>
            </mat-card>
        </div>
        </div>


        <div [class]="displayBread">
        <div [class]="breadStatus">
            <mat-card id="item">

                <div class="line"></div>
                <div style="width: 100%;text-align: right;padding-right: 10px;cursor: pointer;">
                    <mat-icon style="color: #67b758;" (click)="cancelBread()">close</mat-icon>
                </div>
                <div class="row1">
                    <div class="wastename">
                        <p style="padding-top: 10px;">{{publicservice.Texts.Texts['waste-list7']}}</p>
                    </div>

                    <div class="counter">
                        <button mat-mini-fab color="white" style="color:white" aria-label="profile icon"
                            (click)="breadIncrease()" class="btn">
                            <mat-icon class="btnicon">add</mat-icon>
                        </button>
                        <p style="margin-right: 7px;padding-left: 7px;padding-top: 7px;" class="counternum">
                            {{breadCounter}}
                        </p>
                        <button mat-mini-fab color="white" style="color:white" aria-label="profile icon"
                            (click)="breadDecrease()" class="btn">
                            <mat-icon class="btnicon">remove</mat-icon>
                        </button>
                    </div>
                </div>

                <div class="row2">
                    <div class="perkiloprice">
                        <p>{{publicservice.Texts.Texts["selected-items2"]}}</p>
                        <p style="padding-right: 5px;">{{breadPerKilo}}</p>
                    </div>
                    <div class="maxprice">
                        <p>{{publicservice.Texts.Texts["selected-items1"]}}</p>
                        <p style="padding-right: 5px;">{{breadMaxPrice}}</p>
                    </div>

                </div>
            </mat-card>
        </div>
        </div>






        <!-- </div> -->
        <div class="addwastebtndiv">
            <button mat-fab color="white" style="color:white" aria-label="profile icon" (click)="addwaste()"
                class="addwastebtn">
                <mat-icon>add_circle_outline</mat-icon>
            </button>
        </div>


        <div class="done-btn">
            <mat-spinner id="loading" *ngIf="loading"></mat-spinner>

            <button mat-button type="button" class="done" (click)="doneclick()">
                {{publicservice.Texts.Texts['selected-items3']}}
            </button>
        </div>

    </div>
</div>